
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/social-luke",
      function () {
        return require("private-next-pages/success-stories/social-luke/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/social-luke"])
      });
    }
  